import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../services/entities-service.service';

@Component({
  selector: 'app-entities-top-attributes',
  templateUrl: './entities-top-attributes.component.html',
  styleUrls: ['./entities-top-attributes.component.css'],
})
export class EntitiesTopAttributesComponent implements OnInit {
  @Input() config: any;
  @Input() refreshRate: any;
  @Input() entityDetails: any;
  @Input() fromDate: string;
  @Input() toDate : string;
  activeAlertsCount: any;
  token: any = ApiConstants.blobSasToken;
  masterAttributeList: any = [
    {
      attributeName: 'No Data',
      imgUrl: '../../../../assets/images/no-icon-trl.svg',
    },
    {
      attributeName: 'No Data',
      imgUrl: '../../../../assets/images/no-icon-trl.svg',
    },
    {
      attributeName: 'No Data',
      imgUrl: '../../../../assets/images/no-icon-trl.svg',
    },
  ];
  monotainerState: any;
  tenantConfig: any = {};
  driveScore: number = null;
  ufcCustomAttributes: any = [];
  currentTime: Date = new Date();

  private _dynamicEntityData: any = [];
  private _startTime: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    0,
    0,
    0,
    999
  );
  private _filterLists: any[] = [];
  private _intervalTimer: any;
  private _subscription: Subscription;
  private _monotainerDetailsSubscription: Subscription;
  private _getAlertsCountSubscription: Subscription;
  private _getEntityDataSubscription: Subscription;

  // dummyImageUrl: any = 'https://nsclusterhdistorage.blob.core.windows.net/idec-app-blob-files/idec_face/documents/global/header-category-default.svg';

  constructor(
    private _router: Router,
    private _service: EntitiesServiceService,
    private _datePipe: DatePipe,
    private _dataSer: DataService,
    public sharedService: ServicecallService
  ) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (
        res.name === 'siteChanged' ||
        res.name === 'apiRefresh' ||
        res.name === 'tagRefresh'
      ) {
        this.onConditionCheck();
      } else if (res.name === 'driveScore') {
        this.driveScore = res?.args?.length ? res?.args[0] : null;
        this.driveScore = Number.isInteger(this.driveScore)
          ? this.driveScore
          : +this.driveScore?.toFixed(2);
      }
    });
  }

  ngOnInit(): void {
    this.tenantConfig = this.sharedService.getConfiguration(
      'tenantGenericConfig'
    )
      ? this.sharedService.getConfiguration('tenantGenericConfig')
      : null;
  }

  ngOnChanges() {
    if (this.entityDetails?._id) {
      this.onConditionCheck();
      if (this.entityDetails?.category === 'monotainer') {
        this.masterAttributeList = [];
      }
    }
  }

  getStateLabel(state: string) {
    switch (state) {
      case 'init':
        return 'Available';
      case 'inside':
        return 'In lane';
      case 'outside':
        return 'Outside';
      case 'sortarea':
        return 'Sort Area';
      case 'missing':
        return 'Missing';
      case 'mismatch':
        return 'Misplaced';
      case 'delayed':
        return 'Delayed';
      case 'init_mismatch':
        return 'Untagged';
      default:
        return 'NA';
    }
  }
  ngOnDestroy(): void {
    this._clearTimer();
    this._subscription?.unsubscribe();
    this._monotainerDetailsSubscription?.unsubscribe();
    this._getAlertsCountSubscription?.unsubscribe();
    this._getEntityDataSubscription?.unsubscribe();
  }

  onConditionCheck() {
    this._activeAlertsCountData();
    const configBasedOnCategory = this.sharedService.getConfigurationBasedOnCategory(this.entityDetails);
    this.ufcCustomAttributes = configBasedOnCategory ? configBasedOnCategory?.ufcHighlightedAttributes : [];
    if (!this.ufcCustomAttributes?.length) {
      if (this.entityDetails?.category === 'monotainer') {
        this.getMonotainerData();
      } else {
        this._getEntitiesData();
      }
    } else {
      this.masterAttributeList = this.ufcCustomAttributes;
    }
  }

  /**
   * Actives alert navigation
   */
  activeAlertNavigation() {
    if (this.sharedService.rbacManagement('entities_Alerts')) {
      this._dataSer.broadcast('navigateToAlert');
    } else {
      this._router.navigate(['events/alerts', this.entityDetails?._id]);
    }
  }

  getMonotainerData() {
    const reqData = {
      siteId: this.entityDetails?.site?._id
        ? this.entityDetails?.site?._id
        : null,
      entityId: this.entityDetails?._id,
      category: 'monotainer',
      type: '2',
    };
    this._monotainerDetailsSubscription = this._service
      .monotainerDetails(reqData)
      .subscribe({
        next: (result: any) => {
          if (Object.keys(result)?.length) {
            this.monotainerState = result?.state;
          }
        },
        error: () => { },
      });
  }

  private _refreshApi() {
    if (+this.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this.onConditionCheck();
      }, +this.refreshRate);
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _activeAlertsCountData() {
    let configStartDate = null;
    let configEndDate = null;

    if (this.tenantConfig?.defaultTimeRange) {
      const configHour = this.tenantConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    this._filterLists = [{ type: 'Status', value: 'active' }];
    const reqData = {
      filterList: this._filterLists,
      from: this._datePipe.transform(this.fromDate ?? (configStartDate?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate?? Date.now()) , 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      entityId: this.entityDetails?._id,
    };
    this._getAlertsCountSubscription = this.sharedService
      .getAlertsCount(reqData, false)
      .subscribe((result: any) => {
        if (result['status']) {
          const status = result['response']['data'].find(
            (item: any) => item.status
          )?.status;
          if (status) {
            this.activeAlertsCount = status
              ? status.find((item: any) => item.status)?.count
              : undefined;
          }
        } else {
          this.sharedService.toasterService({
            type: 'error',
            msg: result?.response?.message,
          });
        }
      });
  }
  private _getTopattributes() {
    return this.sharedService.getConfigurationBasedOnCategory(
      this.entityDetails
    )
      ? this.sharedService.getConfigurationBasedOnCategory(this.entityDetails)
        .highlightedAttributes
      : [];
  }
  private _getEntitiesData() {
    let configStartDate = null;
    let configEndDate = null;

    if (this.tenantConfig?.defaultTimeRange) {
      const configHour = this.tenantConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const reqData = {
      from: this._datePipe.transform(this.fromDate ?? (configStartDate?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      entityId: this.entityDetails?._id,
      entityCategory: this.entityDetails?.category,
      attributes: this._getTopattributes()?.map((elem: any) => elem.name)
        ?.length
        ? this._getTopattributes()?.map((elem: any) => elem.name)
        : undefined,
    };
    this._getEntityDataSubscription = this._service
      .getEntityData(reqData)
      .subscribe({
        next: (result: any) => {
          if (result['status']) {
            if (result['response']['data']) {
              this._dynamicEntityData = [];
              this._dynamicEntityData = this._getTopattributes();
              if (result['response']['data']?.length) {
                [...result['response']['data'][0]?.attributes].forEach(
                  (elem: any) => {
                    const attIndex = this._dynamicEntityData?.findIndex(
                      (item: any) => item?.name === elem?.attributeName
                    );
                    this._dynamicEntityData[attIndex] = {
                      ...this._getTopattributes()?.[attIndex],
                      ...elem
                    };
                    this._dynamicEntityData[attIndex]['uom'] = this._getTopattributes()?.[attIndex]?.uom;
                    this._dynamicEntityData[attIndex]['name'] = this._getTopattributes()?.[attIndex]?.name;
                    this._dynamicEntityData[attIndex]['attributeName'] = this._getTopattributes()?.[attIndex]?.attributeName 
                      ?? this._getTopattributes()?.[attIndex]?.name;
                    if (this._getTopattributes()?.[attIndex]?.attributeValue) {
                      this._dynamicEntityData[attIndex]['attributeValue'] = this._getTopattributes()?.[attIndex]?.attributeValue;
                    }
                  }
                );
              }
              this._dynamicEntityData.map(
                (attr: any) =>
                  (attr['attributeName'] = attr?.attributeName ?? (attr?.name ? attr?.name : ''))
              );
            } else {
              this._dynamicEntityData = [];
            }
          } else {
            this._dynamicEntityData = [];
          }
          this.masterAttributeList = [];
          this.masterAttributeList = this._dynamicEntityData;
          const indexLength =
            this.entityDetails?.category === 'monotainer' ? 1 : 3;
          for (
            let index = this.masterAttributeList
              ? this.masterAttributeList.length + 1
              : 1;
            index <= indexLength;
            index++
          ) {
            this.masterAttributeList.push({ attributeName: 'No Data' });
          }
          if (this.masterAttributeList?.length && this.config?.length) {
            this._getIcons();
          }
          this._refreshApi();
        },
        error: (error) => {
          if (error) {
            this.masterAttributeList = [];
            this.masterAttributeList = this._dynamicEntityData;
            for (
              let index = this.masterAttributeList
                ? this.masterAttributeList.length + 1
                : 1;
              index <= 3;
              index++
            ) {
              this.masterAttributeList.push({ attributeName: 'No Data' });
            }
            if (this.masterAttributeList?.length && this.config?.length) {
              this._getIcons();
            }
            this._refreshApi();
          }
        },
      });
  }
  private _getIcons() {
    this.masterAttributeList?.map((element: any) => {
      element.imgUrl = this._imgFromConfig(element.attributeName, 'imgUrl');
      element.color = this._imgFromConfig(element.attributeName, 'color');
    });
  }

  private _imgFromConfig(type: any, value: any) {
    const imgContent = this.config?.find((item: any) => {
      if (item.attribute === type) {
        return item;
      }
    });
    if (value === 'imgUrl') {
      return imgContent
        ? imgContent.imgUrl
        : '../../../../assets/images/no-icon-trl.svg';
    } else {
      return imgContent?.color;
    }
  }

  /**
   * Gets attribute value
   * @param value 
   * @returns  
   */
  getAttributeValue(value : any) {
    return Number(value)?.toFixed(2);
  }
}
